import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import HeroSection from '../components/home/HeroSection';
import ImageGallery from '../components/home/ImageGallery';
import PropertyOverview from '../components/home/PropertyOverview';
import Amenities from '../components/home/Amenities';
import FindUsEasily from '../components/home/FindUsEasily';
import BookingPlatforms from '../components/home/BookingPlatforms';
import HostInfo from '../components/home/HostInfo';
import GuestReviews from '../components/home/GuestReviews';

const HomePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    // Check if we need to scroll to a specific section
    const scrollTo = searchParams.get('scrollTo');
    if (scrollTo) {
      setTimeout(() => {
        const targetElement = document.getElementById(scrollTo);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500); // Small delay to ensure the page is fully loaded
    }
  }, [searchParams]);
  
  return (
    <Layout>
      {/* Full-width hero section */}
      <div className="w-full">
        <HeroSection />
      </div>
      
      {/* Contained sections with consistent spacing */}
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16 py-8 md:py-12">
        <section className="pt-8">
          <PropertyOverview />
        </section>
        
        <section>
          <ImageGallery />
        </section>
        
        <section>
          <Amenities />
        </section>
        
        <section>
          <FindUsEasily />
        </section>
        
        <section className="w-full mb-16">
          <HostInfo />
        </section>
        
        <section className="w-full mb-16">
          <GuestReviews />
        </section>
        
        <section id="booking-platforms">
          <BookingPlatforms />
        </section>
      </div>
    </Layout>
  );
};

export default HomePage;
